export interface Chapter {
  id: string;
  num: number;
  title: string;
  pages: string[];
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  status: '连载中' | '已完结';
  categories: string[];
  description: string;
  cover: string;
  rating: number;
  views: string;
  favorites: string;
  updateTime: string;
  latestChapter: string;
  chapters: Chapter[];
}

export const comicPages: string[] = [
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20school%20classroom%20with%20students%20studying%20at%20desks%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20pastel%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text%20no%20speech%20bubbles&width=750&height=1000&seq=page-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20cozy%20boarding%20house%20living%20room%20with%20warm%20lamp%20light%20and%20soft%20sofa%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20caramel%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20school%20hallway%20with%20students%20walking%20and%20chatting%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20pastel%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20school%20rooftop%20with%20two%20students%20looking%20at%20sunset%20sky%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20orange%20pink%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20cozy%20kitchen%20dining%20scene%20with%20warm%20food%20on%20wooden%20table%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20cream%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20library%20reading%20corner%20with%20bookshelves%20and%20warm%20desk%20lamp%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20beige%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-06&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20rainy%20window%20with%20student%20drinking%20hot%20tea%20looking%20outside%2C%20thin%20elegant%20line%20art%2C%20soft%20cool%20warm%20pastel%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-07&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20park%20bench%20under%20big%20tree%20with%20falling%20leaves%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20autumn%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-08&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20small%20convenience%20store%20interior%20with%20warm%20glowing%20shelves%20at%20night%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20amber%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-09&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20school%20festival%20evening%20with%20paper%20lanterns%20and%20smiling%20students%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20festive%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-10&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20street%20cafe%20terrace%20with%20two%20friends%20talking%20over%20drinks%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20cream%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-11&orientation=portrait',
  'https://readdy.ai/api/search-image?query=clean%20Korean%20webtoon%20style%20manga%20page%20illustration%2C%20cozy%20bedroom%20with%20warm%20blanket%20and%20desk%20lamp%20night%20scene%2C%20thin%20elegant%20line%20art%2C%20soft%20warm%20amber%20colors%2C%20minimal%20clean%20background%2C%20slice%20of%20life%20mood%2C%20no%20text&width=750&height=1000&seq=page-12&orientation=portrait',
];

export const comics: Comic[] = [
  {
    id: 'jsrj',
    title: '寄宿日记',
    author: '嫌疑犯H & 金Zetta',
    status: '连载中',
    categories: ['romance', 'campus'],
    description:
      '大一新生俊宇因故寄宿在学校附近的朋友家中，陌生的环境、热心的室友，还有楼下总是飘来饭菜香的阿姨。平凡的日子因为一次次的相遇变得不再平凡，温暖的寄宿生活里，故事正在悄悄发生。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20wholesome%20romance%20comic%20cover%20illustration%2C%20cheerful%20college%20freshman%20boy%20with%20two%20warm%20friendly%20women%20in%20a%20cozy%20wooden%20boarding%20house%20living%20room%2C%20warm%20caramel%20and%20cream%20color%20palette%2C%20clean%20vector%20art%2C%20soft%20golden%20sunlight%2C%20wholesome%20slice%20of%20life%20mood%2C%20simple%20warm%20background%2C%20no%20text&width=600&height=800&seq=cover-jsrj&orientation=portrait',
    rating: 9.4,
    views: '1.2亿',
    favorites: '256.8万',
    updateTime: '2026-08-14',
    latestChapter: '第16话 新的开始',
    chapters: [
      { id: 'jsrj-1', num: 1, title: '初到寄宿之家', pages: comicPages },
      { id: 'jsrj-2', num: 2, title: '深夜的动静', pages: comicPages },
      { id: 'jsrj-3', num: 3, title: '早餐时刻', pages: comicPages },
      { id: 'jsrj-4', num: 4, title: '一起上学', pages: comicPages },
      { id: 'jsrj-5', num: 5, title: '邻居的邀请', pages: comicPages },
      { id: 'jsrj-6', num: 6, title: '图书馆偶遇', pages: comicPages },
      { id: 'jsrj-7', num: 7, title: '周末大扫除', pages: comicPages },
      { id: 'jsrj-8', num: 8, title: '停电的夜晚', pages: comicPages },
      { id: 'jsrj-9', num: 9, title: '天台谈心', pages: comicPages },
      { id: 'jsrj-10', num: 10, title: '生病照顾', pages: comicPages },
      { id: 'jsrj-11', num: 11, title: '烟火大会', pages: comicPages },
      { id: 'jsrj-12', num: 12, title: '雨中的伞', pages: comicPages },
      { id: 'jsrj-13', num: 13, title: '生日惊喜', pages: comicPages },
      { id: 'jsrj-14', num: 14, title: '误会与和解', pages: comicPages },
      { id: 'jsrj-15', num: 15, title: '心意渐明', pages: comicPages },
      { id: 'jsrj-16', num: 16, title: '新的开始', pages: comicPages },
    ],
  },
  {
    id: 'ttsyd',
    title: '天台上的约定',
    author: '青果',
    status: '连载中',
    categories: ['romance', 'healing'],
    description:
      '转学来的少女和天台少年偶然相遇，一个总是带着画板，一个总在练习口琴。他们的约定，藏在天台的风里。这是一段关于勇气、成长与守候的温柔故事。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20comic%20cover%20illustration%2C%20boy%20and%20girl%20sharing%20umbrella%20on%20school%20rooftop%20at%20sunset%2C%20warm%20orange%20pink%20sky%2C%20clean%20vector%20art%2C%20soft%20pastel%20colors%2C%20heartwarming%20atmosphere%2C%20minimal%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-ttsyd&orientation=portrait',
    rating: 9.1,
    views: '5620万',
    favorites: '98.3万',
    updateTime: '2026-08-12',
    latestChapter: '第9话 毕业前奏',
    chapters: [
      { id: 'ttsyd-1', num: 1, title: '转学生', pages: comicPages },
      { id: 'ttsyd-2', num: 2, title: '天台相遇', pages: comicPages },
      { id: 'ttsyd-3', num: 3, title: '秘密基地', pages: comicPages },
      { id: 'ttsyd-4', num: 4, title: '一起写作业', pages: comicPages },
      { id: 'ttsyd-5', num: 5, title: '夏日祭', pages: comicPages },
      { id: 'ttsyd-6', num: 6, title: '争吵', pages: comicPages },
      { id: 'ttsyd-7', num: 7, title: '和好如初', pages: comicPages },
      { id: 'ttsyd-8', num: 8, title: '黄昏约定', pages: comicPages },
      { id: 'ttsyd-9', num: 9, title: '毕业前奏', pages: comicPages },
    ],
  },
  {
    id: 'tzdn',
    title: '同桌的你',
    author: '木木三',
    status: '已完结',
    categories: ['campus', 'daily'],
    description:
      '高中三年，从陌生到默契，从传纸条到并肩作战。每一张课桌都藏着青春的秘密，而我的同桌，是青春里最特别的那一个。清新治愈的校园日常故事。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20campus%20comic%20cover%20illustration%2C%20two%20high%20school%20students%20sitting%20at%20desk%20in%20bright%20classroom%2C%20warm%20sunlight%20through%20window%2C%20clean%20vector%20art%2C%20soft%20cream%20and%20beige%20tones%2C%20cheerful%20atmosphere%2C%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-tzdn&orientation=portrait',
    rating: 8.9,
    views: '4360万',
    favorites: '76.1万',
    updateTime: '2026-07-30',
    latestChapter: '第8话 期末倒计时',
    chapters: [
      { id: 'tzdn-1', num: 1, title: '新同桌', pages: comicPages },
      { id: 'tzdn-2', num: 2, title: '迟到风波', pages: comicPages },
      { id: 'tzdn-3', num: 3, title: '值日生', pages: comicPages },
      { id: 'tzdn-4', num: 4, title: '篮球赛', pages: comicPages },
      { id: 'tzdn-5', num: 5, title: '期中考', pages: comicPages },
      { id: 'tzdn-6', num: 6, title: '运动会', pages: comicPages },
      { id: 'tzdn-7', num: 7, title: '文化祭', pages: comicPages },
      { id: 'tzdn-8', num: 8, title: '期末倒计时', pages: comicPages },
    ],
  },
  {
    id: 'sybld',
    title: '深夜便利店',
    author: '阿茶',
    status: '连载中',
    categories: ['daily', 'healing'],
    description:
      '凌晨两点的便利店，像城市里的一盏小灯。加班的青年、失恋的女孩、赶稿的漫画家……每个人推门进来时，都带着自己的故事。一碗关东煮，足以治愈深夜的疲惫。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20comic%20cover%20illustration%2C%20cozy%20convenience%20store%20at%20night%20with%20warm%20glowing%20lights%2C%20cute%20clerk%20behind%20counter%20serving%20steaming%20hot%20food%2C%20warm%20amber%20color%20palette%2C%20clean%20vector%20art%2C%20comforting%20mood%2C%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-sybld&orientation=portrait',
    rating: 9.3,
    views: '6880万',
    favorites: '120.5万',
    updateTime: '2026-08-13',
    latestChapter: '第8话 清晨打烊',
    chapters: [
      { id: 'sybld-1', num: 1, title: '深夜来客', pages: comicPages },
      { id: 'sybld-2', num: 2, title: '关东煮的温暖', pages: comicPages },
      { id: 'sybld-3', num: 3, title: '雨夜常客', pages: comicPages },
      { id: 'sybld-4', num: 4, title: '加班族的夜宵', pages: comicPages },
      { id: 'sybld-5', num: 5, title: '失恋的客人', pages: comicPages },
      { id: 'sybld-6', num: 6, title: '生日蛋糕', pages: comicPages },
      { id: 'sybld-7', num: 7, title: '店长的手记', pages: comicPages },
      { id: 'sybld-8', num: 8, title: '清晨打烊', pages: comicPages },
    ],
  },
  {
    id: 'myyt',
    title: '猫与雨天',
    author: '南屿',
    status: '已完结',
    categories: ['daily', 'healing'],
    description:
      '雨天的屋檐下，一只橘猫走进了她的生活。从小心翼翼到彼此依赖，一人一猫在平凡的日子里互相治愈。这是一个关于陪伴、告别与爱的温暖故事。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20healing%20comic%20cover%20illustration%2C%20girl%20holding%20small%20orange%20cat%20under%20umbrella%20in%20gentle%20rain%2C%20cozy%20warm%20teal%20and%20cream%20tones%2C%20clean%20vector%20art%2C%20soft%20heartwarming%20mood%2C%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-myyt&orientation=portrait',
    rating: 9.6,
    views: '9210万',
    favorites: '168.2万',
    updateTime: '2026-06-18',
    latestChapter: '第8话 晴天再见',
    chapters: [
      { id: 'myyt-1', num: 1, title: '屋檐下的猫', pages: comicPages },
      { id: 'myyt-2', num: 2, title: '第一次喂食', pages: comicPages },
      { id: 'myyt-3', num: 3, title: '取名小咪', pages: comicPages },
      { id: 'myyt-4', num: 4, title: '雨天相依', pages: comicPages },
      { id: 'myyt-5', num: 5, title: '猫不见了', pages: comicPages },
      { id: 'myyt-6', num: 6, title: '找回', pages: comicPages },
      { id: 'myyt-7', num: 7, title: '领养日', pages: comicPages },
      { id: 'myyt-8', num: 8, title: '晴天再见', pages: comicPages },
    ],
  },
  {
    id: 'cwdj',
    title: '重逢的季节',
    author: '拾光',
    status: '连载中',
    categories: ['romance', 'healing'],
    description:
      '十年后，他们在秋天的车站重逢。旧时光像落了一地的枫叶，捡起来还是温热。那些没说出口的话、错过的人，这一次，是否来得及重新开始？',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20comic%20cover%20illustration%2C%20mature%20man%20and%20woman%20meeting%20at%20autumn%20railway%20station%20with%20falling%20maple%20leaves%2C%20warm%20brown%20and%20amber%20palette%2C%20clean%20vector%20art%2C%20nostalgic%20tender%20mood%2C%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-cwdj&orientation=portrait',
    rating: 9.0,
    views: '5120万',
    favorites: '85.6万',
    updateTime: '2026-08-10',
    latestChapter: '第9话 共同的未来',
    chapters: [
      { id: 'cwdj-1', num: 1, title: '十年后', pages: comicPages },
      { id: 'cwdj-2', num: 2, title: '车站重逢', pages: comicPages },
      { id: 'cwdj-3', num: 3, title: '旧照片', pages: comicPages },
      { id: 'cwdj-4', num: 4, title: '咖啡馆叙旧', pages: comicPages },
      { id: 'cwdj-5', num: 5, title: '错过的时光', pages: comicPages },
      { id: 'cwdj-6', num: 6, title: '再次心动', pages: comicPages },
      { id: 'cwdj-7', num: 7, title: '坦白', pages: comicPages },
      { id: 'cwdj-8', num: 8, title: '牵手散步', pages: comicPages },
      { id: 'cwdj-9', num: 9, title: '共同的未来', pages: comicPages },
    ],
  },
  {
    id: 'xyt',
    title: '星夜之塔',
    author: '北辰',
    status: '连载中',
    categories: ['fantasy', 'action'],
    description:
      '传说塔顶藏着实现愿望的星之秘宝，只有勇敢者才能抵达。少年艾文踏上征途，一路结识同伴、破解谜题，在星夜的指引下，一步步靠近真相与梦想。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20comic%20cover%20illustration%2C%20young%20mage%20climbing%20magical%20tower%20under%20starry%20night%20sky%2C%20glowing%20constellations%20and%20floating%20light%20orbs%2C%20deep%20midnight%20blue%20and%20gold%20palette%2C%20epic%20adventurous%20mood%2C%20detailed%20clean%20art%2C%20no%20text&width=600&height=800&seq=cover-xyt&orientation=portrait',
    rating: 8.8,
    views: '3860万',
    favorites: '64.2万',
    updateTime: '2026-08-11',
    latestChapter: '第12话 黎明之光',
    chapters: [
      { id: 'xyt-1', num: 1, title: '塔的传说', pages: comicPages },
      { id: 'xyt-2', num: 2, title: '第一层试炼', pages: comicPages },
      { id: 'xyt-3', num: 3, title: '星之契约', pages: comicPages },
      { id: 'xyt-4', num: 4, title: '暗影袭来', pages: comicPages },
      { id: 'xyt-5', num: 5, title: '同伴集结', pages: comicPages },
      { id: 'xyt-6', num: 6, title: '镜之回廊', pages: comicPages },
      { id: 'xyt-7', num: 7, title: '魔导师的背叛', pages: comicPages },
      { id: 'xyt-8', num: 8, title: '失落的钥匙', pages: comicPages },
      { id: 'xyt-9', num: 9, title: '决战前夕', pages: comicPages },
      { id: 'xyt-10', num: 10, title: '星夜之巅', pages: comicPages },
      { id: 'xyt-11', num: 11, title: '新的征途', pages: comicPages },
      { id: 'xyt-12', num: 12, title: '黎明之光', pages: comicPages },
    ],
  },
  {
    id: 'jyx',
    title: '剑与信',
    author: '烽火连城',
    status: '已完结',
    categories: ['action', 'fantasy'],
    description:
      '无名剑士接下了一封神秘的信，从此踏上护信的旅程。战乱年代的少年意气，刀光剑影里的道义与承诺。热血、信念与守护交织的史诗故事。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20action%20fantasy%20comic%20cover%20illustration%2C%20determined%20young%20swordsman%20holding%20sword%20in%20medieval%20town%20square%20at%20dawn%2C%20warm%20heroic%20lighting%2C%20clean%20dynamic%20vector%20art%2C%20adventurous%20mood%2C%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-jyx&orientation=portrait',
    rating: 9.2,
    views: '6040万',
    favorites: '101.7万',
    updateTime: '2026-05-26',
    latestChapter: '第11话 旅程继续',
    chapters: [
      { id: 'jyx-1', num: 1, title: '无名剑士', pages: comicPages },
      { id: 'jyx-2', num: 2, title: '委托', pages: comicPages },
      { id: 'jyx-3', num: 3, title: '迷雾森林', pages: comicPages },
      { id: 'jyx-4', num: 4, title: '铁匠的女儿', pages: comicPages },
      { id: 'jyx-5', num: 5, title: '黑骑士', pages: comicPages },
      { id: 'jyx-6', num: 6, title: '王都之夜', pages: comicPages },
      { id: 'jyx-7', num: 7, title: '真相', pages: comicPages },
      { id: 'jyx-8', num: 8, title: '背叛与守护', pages: comicPages },
      { id: 'jyx-9', num: 9, title: '大决战', pages: comicPages },
      { id: 'jyx-10', num: 10, title: '信与剑', pages: comicPages },
      { id: 'jyx-11', num: 11, title: '旅程继续', pages: comicPages },
    ],
  },
  {
    id: 'mjscj',
    title: '梦境收藏家',
    author: '云朵酱',
    status: '连载中',
    categories: ['fantasy', 'healing'],
    description:
      '少女苏晚拥有进入他人梦境的特殊能力，她收集遗失的梦、修补破碎的梦。每一个梦境背后，都是一段被小心翼翼珍藏的情感。奇幻又治愈的温柔物语。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20comic%20cover%20illustration%2C%20dreamy%20girl%20collecting%20glowing%20dream%20bubbles%20floating%20in%20soft%20pastel%20clouds%2C%20whimsical%20cute%20style%2C%20lavender%20mint%20cream%20palette%2C%20magical%20gentle%20mood%2C%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-mjscj&orientation=portrait',
    rating: 9.5,
    views: '7560万',
    favorites: '143.9万',
    updateTime: '2026-08-09',
    latestChapter: '第10话 收藏家之信',
    chapters: [
      { id: 'mjscj-1', num: 1, title: '梦见怪盗', pages: comicPages },
      { id: 'mjscj-2', num: 2, title: '第一枚梦', pages: comicPages },
      { id: 'mjscj-3', num: 3, title: '别人的梦境', pages: comicPages },
      { id: 'mjscj-4', num: 4, title: '遗失的童年', pages: comicPages },
      { id: 'mjscj-5', num: 5, title: '梦中梦', pages: comicPages },
      { id: 'mjscj-6', num: 6, title: '委托人', pages: comicPages },
      { id: 'mjscj-7', num: 7, title: '美梦成真', pages: comicPages },
      { id: 'mjscj-8', num: 8, title: '告别梦境', pages: comicPages },
      { id: 'mjscj-9', num: 9, title: '现实与梦', pages: comicPages },
      { id: 'mjscj-10', num: 10, title: '收藏家之信', pages: comicPages },
    ],
  },
  {
    id: 'stdm',
    title: '社团的秘密',
    author: '一颗小草莓',
    status: '已完结',
    categories: ['campus', 'daily'],
    description:
      '开学第一天，她误打误撞加入了全校最神秘的"屋顶菜园社"。一群古怪又可爱的社员，在小小的屋顶上种菜、种花，也种下了友谊和青春。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20campus%20comic%20cover%20illustration%2C%20group%20of%20cheerful%20students%20planting%20vegetables%20on%20school%20rooftop%20garden%2C%20warm%20daylight%2C%20clean%20vector%20art%2C%20soft%20green%20and%20cream%20tones%2C%20fun%20cozy%20mood%2C%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-stdm&orientation=portrait',
    rating: 8.7,
    views: '2980万',
    favorites: '52.4万',
    updateTime: '2026-04-12',
    latestChapter: '第8话 社团之夜',
    chapters: [
      { id: 'stdm-1', num: 1, title: '奇怪的社团', pages: comicPages },
      { id: 'stdm-2', num: 2, title: '成员招募', pages: comicPages },
      { id: 'stdm-3', num: 3, title: '第一次活动', pages: comicPages },
      { id: 'stdm-4', num: 4, title: '屋顶菜园', pages: comicPages },
      { id: 'stdm-5', num: 5, title: '社团经费', pages: comicPages },
      { id: 'stdm-6', num: 6, title: '对手社团', pages: comicPages },
      { id: 'stdm-7', num: 7, title: '文化祭展示', pages: comicPages },
      { id: 'stdm-8', num: 8, title: '社团之夜', pages: comicPages },
    ],
  },
  {
    id: 'xdxh',
    title: '心动信号',
    author: '糖分超标',
    status: '连载中',
    categories: ['romance', 'campus'],
    description:
      '校服上的第二颗纽扣、匿名情书、篮球场边的加油声……青春期的每一次心动都有迹可循。这对欢喜冤家的恋爱信号，你能收到吗？',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20comic%20cover%20illustration%2C%20boy%20and%20girl%20holding%20hands%20with%20blushing%20faces%20at%20summer%20festival%2C%20warm%20evening%20light%20and%20paper%20lanterns%2C%20clean%20vector%20art%2C%20sweet%20youthful%20mood%2C%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-xdxh&orientation=portrait',
    rating: 8.9,
    views: '4780万',
    favorites: '88.9万',
    updateTime: '2026-08-08',
    latestChapter: '第10话 我们的开始',
    chapters: [
      { id: 'xdxh-1', num: 1, title: '邻座的心跳', pages: comicPages },
      { id: 'xdxh-2', num: 2, title: '校服纽扣', pages: comicPages },
      { id: 'xdxh-3', num: 3, title: '匿名情书', pages: comicPages },
      { id: 'xdxh-4', num: 4, title: '告白练习', pages: comicPages },
      { id: 'xdxh-5', num: 5, title: '篮球场的视线', pages: comicPages },
      { id: 'xdxh-6', num: 6, title: '夏夜烟火', pages: comicPages },
      { id: 'xdxh-7', num: 7, title: '冷战', pages: comicPages },
      { id: 'xdxh-8', num: 8, title: '迟到的答案', pages: comicPages },
      { id: 'xdxh-9', num: 9, title: '毕业舞会', pages: comicPages },
      { id: 'xdxh-10', num: 10, title: '我们的开始', pages: comicPages },
    ],
  },
  {
    id: 'zzzh',
    title: '转学之后',
    author: '远方来信',
    status: '连载中',
    categories: ['campus', 'romance'],
    description:
      '因为父母工作的原因，林夏在高三那年转学到了陌生的城市。新学校、新同学、新的未知，好在命运让她遇到了愿意并肩的人。关于成长与奔赴的故事。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20campus%20comic%20cover%20illustration%2C%20transfer%20student%20girl%20standing%20at%20new%20school%20gate%20looking%20ahead%20with%20determined%20smile%2C%20spring%20cherry%20blossom%20tones%2C%20clean%20vector%20art%2C%20warm%20hopeful%20mood%2C%20simple%20background%2C%20no%20text&width=600&height=800&seq=cover-zzzh&orientation=portrait',
    rating: 8.6,
    views: '3240万',
    favorites: '56.8万',
    updateTime: '2026-08-07',
    latestChapter: '第9话 留下来',
    chapters: [
      { id: 'zzzh-1', num: 1, title: '新的城市', pages: comicPages },
      { id: 'zzzh-2', num: 2, title: '陌生教室', pages: comicPages },
      { id: 'zzzh-3', num: 3, title: '第一个朋友', pages: comicPages },
      { id: 'zzzh-4', num: 4, title: '校门口的偶遇', pages: comicPages },
      { id: 'zzzh-5', num: 5, title: '补习班同桌', pages: comicPages },
      { id: 'zzzh-6', num: 6, title: '天台秘密', pages: comicPages },
      { id: 'zzzh-7', num: 7, title: '转校生之约', pages: comicPages },
      { id: 'zzzh-8', num: 8, title: '回家路上', pages: comicPages },
      { id: 'zzzh-9', num: 9, title: '留下来', pages: comicPages },
    ],
  },
];